<template>
	<div class="mobile-location-nav">
		<div class="horizontal-divider" />
		<div class="location-button">
			<nuxt-link :to="localePath('hotels')" @click="$emit('hide-nav')">
				<span>{{ $t('hotels') }}</span>
				<font-awesome-icon :icon="`fal fa-chevron-right`" size="1x" />
			</nuxt-link>
		</div>
		<div class="horizontal-divider" />
		<div class="location-button">
			<nuxt-link :to="localePath('restaurants')" @click="$emit('hide-nav')">
				<span>{{ $t('restaurants') }}</span>
				<font-awesome-icon :icon="`fal fa-chevron-right`" size="1x" />
			</nuxt-link>
		</div>
		<div class="horizontal-divider" />
		<div class="location-button">
			<nuxt-link :to="localePath('gallery')" @click="$emit('hide-nav')">
				<span>{{ $t('gallery') }}</span>
				<font-awesome-icon :icon="`fal fa-chevron-right`" size="1x" />
			</nuxt-link>
		</div>
		<div class="horizontal-divider" />
	</div>
</template>

<script setup>
defineEmits(['hide-nav']);
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.mobile-location-nav {
	display: none;
	margin: 20px 0 40px;
	width: 100%;

	.horizontal-divider {
		height: 1px;
	}

	.location-button {
		cursor: pointer;

		a,
		a:hover {
			padding: 10px 0;
			color: var(--body-color);
			text-decoration: none;
			background: none;
			display: flex;
			flex-flow: row nowrap;
			justify-content: space-between;
			align-items: center;

			svg {
				font-size: 20px;
			}

			&::after {
				display: none;
			}
		}
	}

	span {
		text-transform: uppercase;
		font-weight: 800;
		font-size: 16px;
		letter-spacing: 1px;
	}
}

@media (max-width: 1200px) {
	.mobile-location-nav {
		display: block;
	}
}
</style>
